import React from 'react';
import { Accordion } from 'components/accordion';
import GuidesSidebarItem from './guides-sidebar-item';
import { GuidesSidebarItemProps } from './guides-sidebar-item.type';

const UNKNOWN_ITEM = null;

export type GuidesSidebarProps = {
    content: GuidesSidebarItemProps[];
    activeItem?: number;
};

const GuidesSidebar: React.FC<GuidesSidebarProps> = ({ content, activeItem = UNKNOWN_ITEM }) => {
    const [activeEventKey, setActiveEventKey] = React.useState(activeItem);
    const onToggleHandler = (index: number | null) => setActiveEventKey(index);
    const onToggle = (event: number) => onToggleHandler(event);
    const onCloseHandler = () => onToggleHandler(UNKNOWN_ITEM);

    return (
        <Accordion activeEventKey={activeEventKey} onToggle={onToggle}>
            <ul className="guides-toggle-cards" role="list">
                {content.map((item, index) =>
                    item ? (
                        <GuidesSidebarItem
                            index={index}
                            activeEventKey={activeEventKey}
                            onCloseHandler={onCloseHandler}
                            key={index}
                            {...item}
                        />
                    ) : null
                )}
            </ul>
        </Accordion>
    );
};

export default GuidesSidebar;
